import {CALENDARSAVE} from '../../../constants';

export const calendar = {
    save: (item) => {
        return { type: CALENDARSAVE, data: item };
    }
};
